// generated during release, do not modify

/**
 * The current version, as set in package.json.
 * @type {string}
 */
export const VERSION = '5.28.6';
export const PUBLIC_VERSION = '5';
